import { render, staticRenderFns } from "./CarouselActivity.vue?vue&type=template&id=ced1e158&scoped=true"
import script from "./CarouselActivity.vue?vue&type=script&lang=js"
export * from "./CarouselActivity.vue?vue&type=script&lang=js"
import style0 from "./CarouselActivity.vue?vue&type=style&index=0&id=ced1e158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced1e158",
  null
  
)

export default component.exports